module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "watermark"
    }
  }, [_vm._v("©Copyright 2015- ArrowHead Economics LLC")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    attrs: {
      "id": "reportHeader"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.showVideo) ? _c('video-player', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    model: {
      value: (_vm.videoModel),
      callback: function($$v) {
        _vm.videoModel = $$v
      },
      expression: "videoModel"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "contentDiv",
      "hidden": ""
    }
  }), _vm._v(" "), _vm._m(2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "height": "82%",
      "position": "fixed",
      "width": "20%"
    },
    attrs: {
      "id": "treeDiv"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-20"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "pdfDiv",
      "hidden": ""
    }
  }, [_c('object', {
    staticStyle: {
      "width": "100%",
      "height": "800px"
    },
    attrs: {
      "id": "pdf-viewer",
      "data": "..\\..\\Help\\Site Update Notifications\\ArrowHead Modeling Platform Site Update 2015-08-11.pdf",
      "type": "application/pdf"
    }
  }, [_c('p', [_vm._v("Error: no pdf viewer detected")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6cbc2f96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cbc2f96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/help/help-index.vue.html
// module id = 1113
// module chunks = 0